<header class="header-2" data-test-id="formular-creation-dialog">
  <div class="branding">
    <span class="title" data-test-id="formular-creation-title">{{ 'Werksabnahme konfigurieren' | mrTranslate }}</span>
  </div>
  <div class="header-actions">
    <clr-dropdown>
      <button class="nav-icon" clrDropdownTrigger aria-label="toggle settings menu" data-test-id="fat-vorlage-settings">
        <cds-icon shape="cog" />
      </button>
      <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
        <a (click)="addFormulare()" clrDropdownItem data-test-id="fat-vorlage-neue-erstellen">
          {{ 'Neue Vorlage erstellen' | mrTranslate }}
        </a>

        @if (selectionvorlageID) {
          <div>
            <a (click)="showRename = true" clrDropdownItem data-test-id="fat-vorlage-umbenennen">
              {{ 'Vorlage umbenennen' | mrTranslate }}
            </a>
            <a (click)="saveAsFormulare()" clrDropdownItem data-test-id="fat-vorlage-speichern-unter">
              {{ 'Vorlage speichern unter...' | mrTranslate }}
            </a>
            <a (click)="deleteFormulare()" clrDropdownItem data-test-id="fat-vorlage-loeschen">
              {{ 'Vorlage löschen' | mrTranslate }}
            </a>
          </div>
        }

        <div class="dropdown-divider" role="separator"></div>
        <a (click)="addTabelle()" clrDropdownItem data-test-id="fat-tabelle-neue-erstellen">
          {{ 'Neue Tabelle erstellen' | mrTranslate }}
        </a>

        @if (selectedTabelleID) {
          <div>
            <a (click)="renameTabelle()" clrDropdownItem data-test-id="fat-tabelle-umbenennen">
              {{ 'Tabelle umbenennen' | mrTranslate }}
            </a>
            <a (click)="saveAsTabelle()" clrDropdownItem data-test-id="fat-tabelle-speichern-unter">
              {{ 'Tabelle speichern unter...' | mrTranslate }}
            </a>
            <a (click)="deleteTabelle()" clrDropdownItem data-test-id="fat-tabelle-loeschen">
              {{ 'Tabelle löschen' | mrTranslate }}
            </a>
          </div>
        }

        <!-- <div *ngIf="UseKomponenten === true" class="dropdown-divider" role="separator"></div>
        <a *ngIf="UseKomponenten === true" (click)="addKomponenten()" clrDropdownItem>{{'Neue Komponente erstellen' | mrTranslate}}</a>
        <a *ngIf="selnodeid !== 0" (click)="editKomponenten()" clrDropdownItem>{{'Komponente bearbeiten' | mrTranslate}}</a>
        <a *ngIf="selnodeid !== 0" (click)="delKomponenten()" clrDropdownItem>{{'Komponente löschen' | mrTranslate}}</a> -->
      </clr-dropdown-menu>
    </clr-dropdown>
    <a href="javascript://" class="nav-link nav-icon" data-test-id="fat-vorlage-close">
      <cds-icon shape="times" (click)="close()" />
    </a>
  </div>
</header>

<div class="overlay-inner-wrapper" style="height: calc(100% + 60px)">
  <div id="datenTabs">
    <clr-tabs>
      <!-- 1. TAB: FORMULARERSTELLUNG -->
      <clr-tab>
        <button
          clrTabLink
          (click)="tabChange()"
          [title]="'Formularerstellung' | mrTranslate"
          data-test-id="fat-tab-vorlagen">
          {{ 'Vorlagen' | mrTranslate | titlecase }}
        </button>
        <clr-tab-content *clrIfActive>
          <div id="formularerstellungsWrapper">
            <div class="clr-row">
              @if (formulare) {
                <div class="clr-col-12">
                  @if (canEdit) {
                    <button class="btn btn-sm" (click)="triggerLock()" data-test-id="fat-vorlage-lock-toggle">
                      <cds-icon [shape]="locked ? 'lock' : 'unlock'" />
                    </button>
                  }
                  @if (!locked) {
                    <button class="btn btn-sm" (click)="addForFormulare()" data-test-id="fat-vorlage-zeile-hinzufuegen">
                      + {{ 'Zeile hinzufügen' | mrTranslate }}
                    </button>
                  }
                  @if (!locked && delItems.length > 0) {
                    <button class="btn btn-sm" (click)="deleteForFormulare()" data-test-id="fat-vorlage-zeile-loeschen">
                      - {{ 'Zeile löschen' | mrTranslate }}
                    </button>
                  }
                  <!-- <button class="btn btn-sm" (click)="copyFormulare()" *ngIf="selectedVorlageName">{{ 'Vorlage kopieren' | mrTranslate }}</button> -->
                  <clr-select-container style="margin-top: 0px">
                    <select
                      clrSelect
                      [(ngModel)]="selectedVorlageName"
                      (change)="selectVorlageName(selectedVorlageName)"
                      data-test-id="fat-vorlage-auswahl">
                      @for (name of vorlageNames; track name) {
                        <option [value]="name.VorlageName">{{ name.VorlageName }}</option>
                      }
                    </select>
                  </clr-select-container>
                  @if (selectedformulare) {
                    <div class="inline-block float-right">
                      @if (cansortup) {
                        <cds-icon
                          size="24"
                          shape="arrow"
                          (click)="sortUp()"
                          class="cursor-pointer"
                          data-test-id="fat-vorlage-sort-up" />
                      }
                      @if (cansortdown) {
                        <cds-icon
                          size="24"
                          shape="arrow"
                          (click)="sortDown()"
                          class="cursor-pointer"
                          style="transform: rotate(180deg)"
                          data-test-id="fat-vorlage-sort-down" />
                      }
                    </div>
                  }
                  @if (locked) {
                    <div>
                      <div class="limit-height" data-test-id="fat-vorlage-table-container-locked">
                        <clr-datagrid
                          #grid
                          style="padding-top: 0px"
                          class="datagrid-compact"
                          [clrDgRowSelection]="true"
                          [clrDgSelectionType]="'single'"
                          [clrDgSelected]="[selectedformulare]"
                          (clrDgSelectedChange)="selectedformulare = $event[0]; selectionFormulareChanged($event[0])"
                          data-test-id="fat-vorlage-datagrid-locked">
                          @for (column of formulare.columns; track column) {
                            <clr-dg-column [clrDgField]="column.id">
                              <ng-container
                                *clrDgHideableColumn="{
                                  hidden:
                                    column.id
                                    | hideIDColumns
                                      : [
                                          'sorting',
                                          'Sorting',
                                          'schhmax',
                                          'SchHMax',
                                          'bildbase64',
                                          'BildBase64',
                                          'profil',
                                          'Profil',
                                          'intid',
                                          'INTID',
                                          'vorlageid',
                                          'VorlageID',
                                          'delstatus',
                                          'status',
                                          'username',
                                        ],
                                }">
                                {{ column.id | mrTranslate | titlecase }}
                              </ng-container>
                            </clr-dg-column>
                          }
                          <clr-dg-row
                            *clrDgItems="let row of formulare.rows; trackBy: trackById"
                            [clrDgItem]="row"
                            data-test-id="fat-vorlage-row-locked">
                            @for (cell of formulare.columns; track cell; let j = $index) {
                              <clr-dg-cell class="name-cell" data-test-id="fat-vorlage-cell-locked">
                                @if (cell.id !== 'Bezeichnung' && cell.id !== 'Tabelle') {
                                  <span>{{ row[cell.id] | tablePrettyPrint | mrTranslate }}</span>
                                } @else {
                                  <span>
                                    {{
                                      (cell.id === 'Bezeichnung' ? getvalue(row) : getvalueTab(row))
                                        | tablePrettyPrint
                                        | mrTranslate
                                    }}
                                  </span>
                                }
                              </clr-dg-cell>
                            }
                          </clr-dg-row>
                          <clr-dg-footer>{{ formulare.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                        </clr-datagrid>
                      </div>
                    </div>
                  } @else {
                    <div class="limit-height" data-test-id="fat-vorlage-table-container">
                      @if (formulare) {
                        <clr-datagrid
                          class="datagrid-compact"
                          style="padding-top: 0px"
                          [clrDgSelectionType]="'single'"
                          [clrDgSelected]="[selectedformulare]"
                          (clrDgSelectedChange)="selectedformulare = $event[0]; selectionFormulareChanged($event[0])"
                          data-test-id="fat-vorlage-datagrid">
                          @if (!locked) {
                            <clr-dg-column class="widthdelete">
                              {{ 'Löschen' | mrTranslate }}
                            </clr-dg-column>
                          }
                          @for (column of formulare.columns; track column) {
                            <clr-dg-column
                              [clrDgField]="column.id"
                              [style.min-width.px]="column.id == 'status' ? 100 : column.id.length * 7.5 + 45">
                              <ng-container
                                *clrDgHideableColumn="{
                                  hidden:
                                    column.id
                                    | hideIDColumns: ['sorting', 'vorlageid', 'delstatus', 'status', 'username'],
                                }">
                                {{ column.id | titlecase | mrTranslate }}
                              </ng-container>
                            </clr-dg-column>
                          }
                          <clr-dg-row
                            *clrDgItems="let row of formulare.rows; trackBy: trackById"
                            [clrDgItem]="row"
                            data-test-id="fat-vorlage-row">
                            @if (!locked) {
                              <clr-dg-cell class="widthdelete" data-test-id="fat-vorlage-cell-delete">
                                <input
                                  type="checkbox"
                                  clrCheckbox
                                  [checked]="delItems.includes(row?.ID ?? row?.id)"
                                  (change)="onItemChanged($event, row, trackById)"
                                  data-test-id="fat-vorlage-row-delete-checkbox" />
                              </clr-dg-cell>
                            }
                            @for (col of formulare.columns; track col) {
                              <clr-dg-cell>
                                @switch (col.id) {
                                  @case (firstColumnId) {
                                    <select
                                      clrInput
                                      [(ngModel)]="row[firstColumnId]"
                                      [disabled]="!canEdit"
                                      data-test-id="fat-vorlage-row-typ-select">
                                      @for (option of typOptions; track option) {
                                        <option [value]="option">{{ option | mrTranslate }}</option>
                                      }
                                    </select>
                                  }
                                  @case (secondColumnId) {
                                    <input
                                      clrInput
                                      type="text"
                                      [(ngModel)]="row[secondColumnId]"
                                      [readonly]="locked"
                                      data-test-id="fat-vorlage-row-feldname-input" />
                                  }
                                  @case ('Tabelle') {
                                    @if (row['Typ'] != 'Überschrift' && row['Typ'] != 'Titel') {
                                      <select
                                        clrInput
                                        type="text"
                                        [(ngModel)]="row['Tabelle']"
                                        [disabled]="!canEdit"
                                        (change)="handleAuswahlOptionChange(row, $event.target.value)"
                                        data-test-id="fat-vorlage-row-tabelle-select">
                                        @for (option of auswahlOptions; track option) {
                                          <option [value]="option">{{ option | mrTranslate }}</option>
                                        }
                                      </select>
                                    } @else {
                                      <span></span>
                                    }
                                  }
                                  @case ('Bezeichnung') {
                                    @if (row['Typ'] != 'Überschrift' && row['Typ'] != 'Titel') {
                                      <select
                                        clrInput
                                        type="text"
                                        [(ngModel)]="row['Bezeichnung']"
                                        [disabled]="!canEdit"
                                        class="datagrid-dropdown"
                                        data-test-id="fat-vorlage-row-bezeichnung-select">
                                        @if (row['Tabelle'] === 'Stammdaten') {
                                          @for (option of stammdaten.rows; track option) {
                                            <option [value]="option.FeldName">
                                              {{ option.Bezeichnung | mrTranslate }}
                                            </option>
                                          }
                                        }
                                        @if (row['Tabelle'] === 'Spezifikationsdaten') {
                                          @for (option of spezifikationsdaten.columns; track option) {
                                            <option [value]="option.value">{{ option.display }}</option>
                                          }
                                        }
                                        @if (row['Tabelle'] === 'Herstellerdaten') {
                                          @for (option of herstellerdaten.columns; track option) {
                                            <option [value]="option">{{ option | mrTranslate }}</option>
                                          }
                                        }
                                      </select>
                                    } @else {
                                      <span></span>
                                    }
                                  }
                                  @default {
                                    <input clrInput type="text" [(ngModel)]="row[col.id]" [readonly]="locked" />
                                  }
                                }
                              </clr-dg-cell>
                            }
                          </clr-dg-row>
                          <clr-dg-footer>{{ formulare.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                        </clr-datagrid>
                      }
                    </div>
                    <button
                      class="btn btn-primary"
                      (click)="sendForFormulare()"
                      id="saveButton"
                      [disabled]="locked"
                      data-test-id="fat-vorlage-daten-speichern">
                      {{ 'Daten speichern' | mrTranslate }}
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        </clr-tab-content>
      </clr-tab>

      <!-- 2. TAB: TABELLENERSTELLUNG -->
      <clr-tab>
        <button
          clrTabLink
          (click)="onMesswerteTabClick()"
          [title]="'Tabellenerstellung' | mrTranslate"
          data-test-id="fat-tab-messwerte">
          {{ 'Messwerte' | mrTranslate | titlecase }}
        </button>
        <clr-tab-content *clrIfActive>
          <div id="tabellenerstellungsWrapper">
            <!-- <app-newtabellenamemodal (reload)="handleModalReload()" style="margin-right:auto; align-self:flex-end;"
              (modalOpen)="_modalOpen = $event">
            </app-newtabellenamemodal> -->

            <div class="clr-row">
              @if (tabellen) {
                <div class="clr-col-12">
                  @if (canEdit) {
                    <button class="btn btn-sm" (click)="triggerLock()" data-test-id="fat-tabelle-lock-toggle">
                      <cds-icon [shape]="locked ? 'lock' : 'unlock'" />
                    </button>
                  }
                  @if (canEdit) {
                    <button class="btn btn-sm" (click)="isHelperModalOpen.set(true)" data-test-id="fat-tabelle-hilfe">
                      {{ 'Hilfe' | mrTranslate }}
                    </button>
                  }
                  @if (!locked) {
                    <button class="btn btn-sm" (click)="addForTabellen()" data-test-id="fat-tabelle-zeile-hinzufuegen">
                      + {{ 'Zeile hinzufügen' | mrTranslate }}
                    </button>
                  }
                  <div class="clr-row">
                    <div class="clr-col-3">
                      <clr-select-container style="margin-top: 0px">
                        <select
                          clrSelect
                          [(ngModel)]="selectedTabelleID"
                          (change)="selectTabelleID(selectedTabelleID)"
                          style="max-width: 300px"
                          data-test-id="fat-tabelle-auswahl">
                          @for (tabelle of tabellenNames; track tabelle) {
                            <option [value]="tabelle.ID">{{ tabelle.Bezeichnung }}</option>
                          }
                        </select>
                      </clr-select-container>
                    </div>
                    <div class="clr-col-3">
                      <label>{{ 'Bereich' | mrTranslate }}: {{ selcode }}</label>
                    </div>
                    <div class="clr-col-6">
                      <form clrForm clrLayout="horizontal" class="bemerkung-form">
                        <clr-input-container>
                          <label>{{ 'Bemerkung' | mrTranslate }}</label>
                          <input
                            clrInput
                            [(ngModel)]="bemerkungmessung"
                            name="bemerkung"
                            [readonly]="locked"
                            data-test-id="fat-tabelle-bemerkung" />
                        </clr-input-container>
                      </form>
                    </div>
                  </div>
                  @if (selectedtabellen) {
                    <div class="inline-block float-right">
                      @if (cansortuptabelle) {
                        <cds-icon size="24" shape="arrow" (click)="sortUptable()" class="cursor-pointer" />
                      }
                      @if (cansortdowntabelle) {
                        <cds-icon
                          size="24"
                          shape="arrow"
                          (click)="sortDowntable()"
                          class="cursor-pointer"
                          style="transform: rotate(180deg)" />
                      }
                    </div>
                  }
                  @if (selmesstyp == 0) {
                    <div class="limit-height-500" data-test-id="fat-tabelle-messung-container">
                      @if (tabellenNames.length > 0) {
                        <clr-datagrid
                          style="padding-top: 0px"
                          class="datagrid-compact"
                          [clrDgSelectionType]="'single'"
                          [clrDgSelected]="[selectedtabellen]"
                          (clrDgSelectedChange)="selectedtabellen = $event[0]; selectionTabellenChanged($event)[0]"
                          data-test-id="fat-tabelle-messung-datagrid">
                          @if (!locked) {
                            <clr-dg-column clrDgField="delete">
                              {{ 'Löschen' | mrTranslate }}
                            </clr-dg-column>
                          }
                          @for (column of tabellen.columns; track column) {
                            <clr-dg-column [clrDgField]="column.id">
                              <ng-container
                                *clrDgHideableColumn="{
                                  hidden: column.id | hideIDColumns: ['i_sort', 'szaehnid', 'zart'],
                                }">
                                {{ column.id | mrTranslate | titlecase }}
                              </ng-container>
                            </clr-dg-column>
                          }
                          <clr-dg-row
                            *clrDgItems="let row of tabellen.rows; let i = index"
                            [clrDgItem]="row"
                            [clrDgSelectionType]="'multi'"
                            [clrDgSelected]="selectedtabellen"
                            data-test-id="fat-tabelle-messung-row"
                            [attr.data-row-index]="i">
                            @if (!locked) {
                              <clr-dg-cell data-test-id="fat-tabelle-messung-delete-cell">
                                <cds-icon
                                  shape="times"
                                  (click)="deleteForTabellen(row['ID'])"
                                  class="cursor-pointer"
                                  data-test-id="fat-tabelle-messung-delete-btn" />
                              </clr-dg-cell>
                            }
                            @for (cell of tabellen.columns; track cell) {
                              <clr-dg-cell [attr.data-test-id]="'fat-tabelle-messung-cell-' + cell.id">
                                <input
                                  clrInput
                                  type="text"
                                  [(ngModel)]="row[cell.id]"
                                  [readonly]="locked"
                                  [attr.data-test-id]="'fat-tabelle-messung-input-' + cell.id" />
                              </clr-dg-cell>
                            }
                          </clr-dg-row>
                          <clr-dg-footer>{{ tabellen.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                        </clr-datagrid>
                      }
                    </div>
                  } @else {
                    <div data-test-id="fat-tabelle-visuell-container">
                      <div class="limit-height-500">
                        @if (tabellenNames.length > 0) {
                          <clr-datagrid
                            style="padding-top: 0px"
                            class="datagrid-compact"
                            [clrDgSelectionType]="'single'"
                            [clrDgSelected]="[selectedtabellen]"
                            (clrDgSelectedChange)="selectedtabellen = $event[0]; selectionTabellenChanged($event[0])"
                            data-test-id="fat-tabelle-visuell-datagrid">
                            @if (!locked) {
                              <clr-dg-column clrDgField="delete">
                                {{ 'Löschen' | mrTranslate }}
                              </clr-dg-column>
                            }
                            @for (column of tabellen.columns; track column) {
                              <clr-dg-column [clrDgField]="column.id">
                                <ng-container
                                  *clrDgHideableColumn="{
                                    hidden:
                                      column.id
                                      | hideIDColumns: ['i_sort', 'szaehnid', 'zart', 'soll', 'tol +', 'tol -'],
                                  }">
                                  {{ column.id | mrTranslate | titlecase }}
                                </ng-container>
                              </clr-dg-column>
                            }
                            <clr-dg-row
                              *clrDgItems="let row of tabellen.rows; let i = index"
                              [clrDgItem]="row"
                              [clrDgSelectionType]="'multi'"
                              [clrDgSelected]="selectedtabellen"
                              data-test-id="fat-tabelle-visuell-row"
                              [attr.data-row-index]="i">
                              @if (!locked) {
                                <clr-dg-cell data-test-id="fat-tabelle-visuell-delete-cell">
                                  <cds-icon
                                    shape="times"
                                    (click)="deleteForTabellen(row['ID'])"
                                    class="cursor-pointer"
                                    data-test-id="fat-tabelle-visuell-delete-btn" />
                                </clr-dg-cell>
                              }
                              @for (cell of tabellen.columns; track cell) {
                                <clr-dg-cell [attr.data-test-id]="'fat-tabelle-visuell-cell-' + cell.id">
                                  <input
                                    clrInput
                                    type="text"
                                    [(ngModel)]="row[cell.id]"
                                    [readonly]="locked"
                                    style="width: calc(50vw)"
                                    [attr.data-test-id]="'fat-tabelle-visuell-input-' + cell.id" />
                                </clr-dg-cell>
                              }
                            </clr-dg-row>
                            <clr-dg-footer>{{ tabellen.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                          </clr-datagrid>
                        }
                      </div>
                    </div>
                  }
                </div>
              }

              <div class="clr-row">
                <div class="clr-col">
                  <button
                    class="btn btn-primary"
                    (click)="sendForTabellen()"
                    id="saveButton"
                    [disabled]="locked"
                    data-test-id="fat-tabelle-daten-speichern">
                    {{ 'Daten speichern' | mrTranslate }}
                  </button>
                </div>
              </div>

              <br />
              <div class="clr-col-12">
                <app-preview-thumbnails
                  #preview
                  [showCamera]="false"
                  [isSkizze]="true"
                  [readonly]="locked"
                  [acceptTypes]="'.png'"
                  [maxAmount]="6"
                  [drag_move]="true"
                  [allowCameraVideo]="false"></app-preview-thumbnails>
              </div>
            </div>
          </div>
        </clr-tab-content>
      </clr-tab>
    </clr-tabs>
  </div>
</div>

<app-hilfe-beschreibung-modal [(isModalOpen)]="isHelperModalOpen" [table]="'SZAEHN'" [id]="tab?.ID" />

<clr-modal [(clrModalOpen)]="isVorlageAddVisible" [clrModalClosable]="true">
  <h3 class="modal-title">{{ modaltitel }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="vertical">
      <div class="clr-row">
        <div class="clr-col-12">
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 300px">
              <input
                id="_aufgroup_name_new"
                class="clr-input combobox"
                placeholder="{{ 'Bezeichnung' | mrTranslate }}"
                #_vorlage_new
                data-test-id="fat-vorlage-neue-name-input" />
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="addVorlage()" data-test-id="fat-vorlage-neue-ok">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="isVorlageAddVisible = false" data-test-id="fat-vorlage-neue-abbrechen">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="isZaehlerAddVisible" [clrModalClosable]="true">
  <h3 class="modal-title">{{ modaltitel | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="vertical" [formGroup]="optionMessTable">
      <div class="clr-row">
        <div class="clr-col-3">
          <label>{{ 'Bereich' | mrTranslate }}</label>
        </div>
        <div class="clr-col-9">
          <div class="clr-control-container" style="width: 300px">
            <input
              class="clr-input combobox"
              type="search"
              name="pruefart"
              #_zaehlercode
              list="pruefartList"
              autocomplete="off"
              data-test-id="fat-tabelle-pruefart-input" />
          </div>
          <datalist id="pruefartList">
            @for (obj of tabellenName; track obj) {
              <option [value]="obj"></option>
            }
          </datalist>
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-3">
          <label>{{ 'Bezeichnung' | mrTranslate }}</label>
        </div>
        <div class="clr-col-9">
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 300px">
              <input
                id="_aufgroup_name_new"
                class="clr-input combobox"
                #_zaehlerbezeichnung
                data-test-id="fat-tabelle-bezeichnung-input" />
            </div>
          </div>
        </div>
      </div>
      <br />
      @if (dorename === 0) {
        <div class="clr-row">
          <div class="clr-col-3">
            <label>{{ 'Typ' | mrTranslate }}</label>
          </div>
          <div class="clr-col-9">
            <clr-select-container style="margin-top: 0px">
              <select clrSelect name="options" formControlName="messart" data-test-id="fat-tabelle-typ-select">
                <option value="0">{{ 'messen' | mrTranslate }}</option>
                <option value="1">{{ 'visuell' | mrTranslate }}</option>
              </select>
            </clr-select-container>
          </div>
        </div>
      }
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="addZaehler()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="isZaehlerAddVisible = false">{{ 'Abbrechen' | mrTranslate }}</button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="showRename" [clrModalSize]="'md'" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Vorlage umbenennen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="horizontal" style="margin-top: -25px">
      <!-- <p>{{ "Bitte geben Sie ihre Email unter ein und sie erhalten eine Bestätigungscode per Email mit dem Sie ihr Passwort zurücksetzten können." | mrTranslate }}</p> -->
      <clr-input-container>
        <label class="clr-col-md-4">{{ 'Neue Bezeichnung' | mrTranslate }}</label>
        <input class="clr-col-md-8" style="width: 300px" clrInput id="exforgotemail" type="email" #newStammBez />
        <br />
      </clr-input-container>
      <br />
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="renameFormulare()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="showRename = false">{{ 'Abbrechen' | mrTranslate }}</button>
  </div>
</clr-modal>
